import { post } from "./httpClient";

export async function login(email: string, password: string, site: string) {
  // Don't cache auth requests and don't send token (no auth yet)
  return post("/auth/login", { email, password, site }, {
    cacheResponse: false,
    headers: {} // Override to not include auth header
  });
}

export async function register(userData: {
  firstName: string;
  lastName: string;
  email: string;
  mobile: string;
  password: string;
  site: string;
}) {
  // Don't cache auth requests and don't send token (no auth yet)
  return post("/auth/register", userData, {
    cacheResponse: false,
    headers: {} // Override to not include auth header
  });
}

export async function changePassword(currentPassword: string, newPassword: string) {
  return post("/auth/change-password", { currentPassword, newPassword }, { cacheResponse: false });
}
